import i18n from "i18next";
import React, { useState, useEffect } from 'react';
import { Fetch } from '../utils/Utils.js';
import SuccessMessage from '../shared/SuccessMessage.js';
import ErrorMessage from '../shared/ErrorMessage.js';
import { useTranslation } from 'react-i18next';

export const ChangeLanguage = (props) => {

  const { t } = useTranslation();
  const [profile, setProfile] = useState([]);
  const [success, setSuccess] = useState("");
  const [error,   setError] = useState("");
  const [language, setLanguage] = useState("");

  const handleLanguage = (e) => {
    const new_lang = e.target.value;
    Fetch('/api/auth/language', 'PATCH', JSON.stringify({ lang: new_lang }),
      () => {
        setSuccess(t('change_successful'));
        setLanguage(new_lang);
        i18n.changeLanguage(new_lang);
        const stored = JSON.parse(localStorage.getItem('zapmanejo_user') || '{}');
        localStorage.setItem('zapmanejo_user', JSON.stringify({ ...stored, lang: new_lang }));
      },
      (err) => {
        console.error('Error updating language');
        setError(err);
      }
    );
  };

  useEffect(() => {
    const url = `/api/data/users`;
    const fetchData = () => {
      Fetch(url, "GET", null, 
        (data) => {
          setProfile(data[0]);
          setLanguage(data[0].lang);
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      );
    }
    fetchData();
  }, []);

  return (
    <form className="DataCollectionAdd">
      <h3>{t("change_pref_lang")}</h3>
      <select name="lang" value={language} 
        onChange={handleLanguage}>
        <option value="en-US">English</option>
        <option value="pt-BR">Português</option>
      </select>
      <SuccessMessage message={success}/>
      <ErrorMessage message={error}/>
    </form>
  );
}

export default ChangeLanguage;
